import React, {useContext, useEffect} from 'react'
import PropTypes from 'prop-types'
import {TextField, Typography, withStyles} from '@material-ui/core';
import getObjectValue from 'libs/getObjectValue'
import Tr from 'translations/Translations';
import clsx from 'clsx';
import INPUT_TYPE from 'constants/INPUT_TYPE'
import toNumberType from "libs/toNumberType";
import AlertsForOfferContext from "../context/AlertsForOfferContext";

const style = theme => ({
    root: {
        position: 'relative',
    },
    limit: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        color: theme.palette.text.secondary,
    },
    error: {
        marginBottom: 10,
    },
    alert: {
        color: "#1976d2",
        marginLeft: "0"
    }
})

function TextInput({
    formikProps,
    id,
    label,
    placeholder,
    className,
    noError,
    noErrorSpace,
    noErrorMargin = false,
    alertText,
    multiline,
    disabled,
    required,
    endAdornment,
    limit,
    type = "text",
    onChange = () => {
    },
    classes,
    step,
    onBlur = () => {
    },
    showErrorImmediately = false,
    fullWidth = true,
	skipCheckTouched,
	...other
}) {
	const errorValue = getObjectValue(id, formikProps.errors, '')
	const touched = getObjectValue(id, formikProps.touched, !!skipCheckTouched)
	const value = getObjectValue(id, formikProps.values, '')
	const editable = getObjectValue('_editable', formikProps.values, true);
    const alertsForOffer = useContext(AlertsForOfferContext);
    let alert = "";
    let isAlert = false;
    const decodePolishCharacters = (str) => {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = str;
        return textArea.value;
    };

    if (alertsForOffer && alertsForOffer instanceof Map && alertsForOffer.has(id) && alertsForOffer.get(id) !== null) {
        alert = alertsForOffer.get(id);
        isAlert = true;
    } else if (!!alertText) {
        alert = alertText;
        isAlert = true;
    } else {
        alert = ("");
        isAlert = false;
    }

    const isError = !noError && (!!errorValue && Boolean(touched))
    const lettersLeft = limit - value.toString().length

    let _label = label;
    let _placeholder = placeholder;
    if (_label && required) _label += '*';
    if (_placeholder && required) _placeholder += '*';


    useEffect(() => {
        if (showErrorImmediately && lettersLeft < 0) {
            formikProps.setFieldTouched(id, true)
        }
        // eslint-disable-next-line
    }, [lettersLeft])

	const handleChange = (e) => {
		let value = e.target.value;
		switch (type) {
			case INPUT_TYPE.NUMBER_19:
			case INPUT_TYPE.NUMBER_19_WITH_NEGATIVE:
				const withMin = INPUT_TYPE.NUMBER_19_WITH_NEGATIVE === type;
				value = toNumberType(value, withMin ? /(?!^-)-|[^0-9.,-]/g : undefined);
				let valueSplit = value.split('.')
				if(valueSplit.length > 2) {
					valueSplit = valueSplit.slice(0, 2)
				}

				if (valueSplit.length > 1) {
					valueSplit[0] = valueSplit[0].slice(0, withMin && value.startsWith("-") ? 14 : 13)
					valueSplit[1] = valueSplit[1].slice(0, 2);
				} else {
					valueSplit[0] = valueSplit[0].slice(0, withMin && value.startsWith("-") ? 14 : 13)
				}
				value = valueSplit.join('.');
				break;
			case INPUT_TYPE.NUMBER_POSITIVE_AMOUNT:
				value = toNumberType(value);
				let valueSplitAmount = value.split('.')
				if(valueSplitAmount.length > 2) {
                    valueSplitAmount = valueSplitAmount.slice(0, 2)
				}

				if (valueSplitAmount.length > 1) {
					valueSplitAmount[0] = valueSplitAmount[0].slice(0, 17)
					valueSplitAmount[1] = valueSplitAmount[1].slice(0, 10);
				} else {
					valueSplitAmount[0] = valueSplitAmount[0].slice(0, 17)
				}
				value = valueSplitAmount.join('.');
				break;
            case INPUT_TYPE.NUMBER_POSITIVE_AMOUNT_3:
                value = toNumberType(value);
                let valueSplitAmount3 = value.split('.')
                if (valueSplitAmount3.length > 2) {
                    valueSplitAmount3 = valueSplitAmount3.slice(0, 2)
                }

                if (valueSplitAmount3.length > 1) {
                    valueSplitAmount3[0] = valueSplitAmount3[0].slice(0, 16)
                    valueSplitAmount3[1] = valueSplitAmount3[1].slice(0, 3);
                } else {
                    valueSplitAmount3[0] = valueSplitAmount3[0].slice(0, 17)
                }
                value = valueSplitAmount3.join('.');
                break;
			case INPUT_TYPE.INTEGER_POSITIVE_AMOUNT:
				value = toNumberType(value, /\D/);
				break;
			case INPUT_TYPE.NUMBER_DECIMAL:
				if (value !== "-") {

					value = toNumberType(value, /(?!(^([-]?)\d|[.,]))\D/);
					const valueSplit1 = value.split('.')
					if (valueSplit1.length > 1) {
						valueSplit1[1] = valueSplit1[1].slice(0, 10);
						valueSplit1[0] = valueSplit1[0].slice(0, 17)
					} else {
						valueSplit1[0] = valueSplit1[0].slice(0, 17)
					}
					value = valueSplit1.filter((x, i) => i < 2).join('.');
				}
				break;
			case INPUT_TYPE.PHONE:
				value = toNumberType(value, /(?!(^([+]?)[ ]*\d|[ ]|^[+]))\D/);
				break;
			default:
				break;
		}

        onChange(value);
        if (type === 'number' || type === 'text') formikProps.handleChange(e)
        else {
            formikProps.setFieldValue(id, value)
            formikProps.setFieldTouched(id, true)
        }
    }

    const handleBlur = (e) => {
        let value = e.target.value;
        let valueChanged = false;
        if (INPUT_TYPE.NUMBER_POSITIVE_AMOUNT_3 === type) {
            value = toNumberType(value);
            let valueSplitAmount3 = value.split('.')
            if (valueSplitAmount3.length > 2) {
                valueSplitAmount3 = valueSplitAmount3.slice(0, 2)
                valueChanged = true;
            }

            if (valueSplitAmount3.length > 1) {
                valueSplitAmount3[0] = valueSplitAmount3[0].slice(0, 16)
                valueSplitAmount3[1] = valueSplitAmount3[1].slice(0, 3);
                if (valueSplitAmount3[1].length < 3) {
                    valueSplitAmount3[1] = valueSplitAmount3[1].padEnd(3, '0');
                    valueChanged = true;
                }
            } else {
                valueSplitAmount3 = [valueSplitAmount3[0], '000'];
                valueSplitAmount3[0] = valueSplitAmount3[0].slice(0, 16);
                valueChanged = true;
            }
            if (valueChanged) {
                value = valueSplitAmount3.join('.');
            }
        }
        if (valueChanged) {
            onChange(value);
            if (type === 'number' || type === 'text') formikProps.handleChange(e)
            else {
                formikProps.setFieldValue(id, value)
                formikProps.setFieldTouched(id, true)
            }
        }
        onBlur(e);
        formikProps.handleBlur(e);
    }

	const inputType = ((type) => {
		switch (type) {
			case INPUT_TYPE.NUMBER_19:
			case INPUT_TYPE.NUMBER_19_WITH_NEGATIVE:
			case INPUT_TYPE.NUMBER_POSITIVE_AMOUNT: return 'text';
			default: return type;
		}
	})(type)

    const formatValue = () => {
        let v = '' + value;
        if (type !== "text") v = v.replace(/\./g, ',')
        return v;
    }

    const resolveHelperText = () => {
        let errorText = noError ? undefined : isError ? errorValue : noErrorSpace ? undefined : ' ';
        if ((!errorText || errorText === ' ') && isAlert)
            errorText = <span className={classes.alert}>{decodePolishCharacters(alert)}</span>;

        return errorText;
    }

    return (
        <div
            className={clsx({[classes.error]: !noErrorMargin && (isError || isAlert)}, classes.root)}
        >
            <TextField
                {...other}

                className={className}
                type={inputType}
                label={_label}
                name={id}
                onChange={handleChange}
                onBlur={handleBlur}
                value={formatValue()}
                error={isError}
                helperText={resolveHelperText()}
                placeholder={_placeholder}
                fullWidth={fullWidth}
                multiline={multiline}
                disabled={disabled || !editable}
                InputProps={{
                    endAdornment,
                }}
                maxRows={limit}
                // eslint-disable-next-line
                inputProps={{
                    step: step,
                    "data-id": id,
                    maxLength: limit
                }}
            />
            {limit &&
                <Typography
                    variant='caption'
                    className={classes.limit}
                >
                    {Tr('characters_left', {number: lettersLeft < 0 ? 0 : lettersLeft})}
                </Typography>
            }
        </div>
    )
}

TextInput.propTypes = {
    formikProps: PropTypes.object,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    noError: PropTypes.bool,
}

TextInput.defaultProps = {
    noError: false,
}

export default withStyles(style)(TextInput)
